import { FC } from 'react'
import { Accordion, Box, Text } from '@mrshmllw/smores-react'

import { ExclusionState } from './exclusion.type'
import { SimpleHeader } from 'components/Header/SimpleHeader'
import { PageWrapper } from 'components/PageWrapper'
import ErrorMarshform from 'assets/images/marshforms/error.svg?react'

import { useTracking } from 'utils'

export const PCWExclusion: FC<ExclusionState> = ({
  exclusionCode,
  quoteId,
  firstQuoteId,
  channel,
}) => {
  useTracking('PCW Exclusion', { firstQuoteId, quoteId, channel, exclusionCode })

  return (
    <>
      <SimpleHeader />
      <PageWrapper maxWidth="630px" mobile="0" pl="0" pr="0">
        <Box mb="12px" flex justifyContent="center">
          <ErrorMarshform />
        </Box>
      </PageWrapper>
      <PageWrapper maxWidth="630px" pl="0" pr="0">
        <Text tag="h2" typo="hero-alternate" mb="8px" align="center">
          Sorry, we can’t cover you. But don’t worry!
        </Text>
        <Text mb="24px" align="center">
          We’d love to insure everyone, but as you can see it’s not always possible.
        </Text>
        <Accordion title="Why can’t you insure me?" fullBorder mb="12px">
          <Text mb="12px">There could be a few reasons why we can’t insure you. For example:</Text>
          <ul>
            <li>&#8226; We may not be able to insure your particular car</li>
            <li>
              &#8226; We may not be able to insure the drivers (they could be too young or too old)
            </li>
            <li>
              &#8226; We may not offer the type of insurance you need (e.g. commercial insurance){' '}
            </li>
          </ul>
        </Accordion>

        <Accordion title="Should I try again with Marshmallow?" fullBorder>
          <Text mb="12px">
            Not yet. Based on the information you’ve given us, we won’t be able to insure you.
          </Text>
          <Text>We’re always working on new things, so do check back on us in the future! </Text>
        </Accordion>
      </PageWrapper>
    </>
  )
}
